import { gql } from 'graphql.macro';

export const getPublishedReleaseNotesTemplate = gql`
    query publishedReleaseNotes($organizationType: ReleaseNoteOrganizationType!) {
        publishedReleaseNotes(organizationType: $organizationType) {
            _id
            version
            translations {
                language
                content
            }
            createdAt
        }
    }
`;

export const getLatestPublishedReleaseNoteTemplate = gql`
    query latestPublishedReleaseNote($organizationType: ReleaseNoteOrganizationType!) {
        latestPublishedReleaseNote(organizationType: $organizationType) {
            _id
            version
            organizationType
            translations {
                language
                content
            }
            createdAt
        }
    }
`;
